import React from 'react';

export const Pictogram = React.memo((props) => {
    const dis = props?.discipline === undefined ? 'glo' : props.discipline.toLowerCase();
    const picto = props?.picto === undefined ? 'none' : props.picto.toLowerCase();
    return (
        <div className="pictogram-main">
            <div className="image-container">
                <picture>
                    <img aria-hidden="true" className='image' src={`/assets/images/pictos/${dis}/${dis}-${picto}.png`} />
                </picture>
            </div>
        </div>
    )
});


